import React, { useState, useRef, useEffect } from 'react';
import { Modal, message } from 'antd';
import dayjs from 'dayjs';
import BasicDetails from './BasicDetails';
import AssignEmployee from './AssignEmployee';
import Summary from './Summary';
import ScheduleStatus from './ScheduleStatus';
import useAuth from '../../hooks/useAuth';
import {
  createCrew,
  scheduleOverride,
  CrewScheduleWorkmen,
  replaceScheduleWorkmen,
} from '../../services/crew';
import { RemoveFilters } from './RemoveFilters';
const MainStepper = ({ step, initialValues = {}, selectedDate = null, templateAccess, scheduleOverridePermission, onReset, onClose }) => {
  const [currentStep, setCurrentStep] = useState(step === 'assignEmployee' ? 1 : 0);
  const [basicDetails, setBasicDetails] = useState(initialValues || {});
  const [assignedEmployees, setAssignedEmployees] = useState(initialValues.employees || []);
  const [removedEmployees, setRemovedEmployees] = useState([]);
  const [editEmployeeStatus, setEditEmployeeStatus] = useState([]);
  const [assignDate, setAssignDate] = useState(null);
  const [integrationResponse, setIntegrationResponse] = useState(null);
  const [scheduleModalVisible, setScheduleModalVisible] = useState(false);
  const [successAssignments, setSuccessAssignments] = useState([]);
  const [conflictAssignments, setConflictAssignments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [createdCrewId, setCreatedCrewId] = useState(null);
  const [formKey, setFormKey] = useState(0);
  const basicDetailsRef = useRef();
  const assignEmployeeRef = useRef();
  const { userConfig } = useAuth();

  const resetStepper = () => {
    setCurrentStep(0);
    setBasicDetails({});
    setAssignedEmployees([]);
    setRemovedEmployees([]);
    setEditEmployeeStatus([]);
    setAssignDate(null);
    setIntegrationResponse(null);
    setScheduleModalVisible(false);
    setSuccessAssignments([]);
    setConflictAssignments([]);
    setCreatedCrewId(null);
    setFormKey(prev => prev + 1)
    setLoading(false);
    basicDetailsRef.current?.resetForm();
  };

  useEffect(() => {
    onReset?.(resetStepper);
  }, [onReset]);

  const handleBasicDetailsNext = async () => {
    if (!basicDetailsRef.current) return;
    try {
      const values = await basicDetailsRef.current.validate();
      setBasicDetails(values);
      setCurrentStep(1);
    } catch {
    }
  };
const handleAssignEmployeeNext = (data) => {
    const assignedEmployees = data.employees;
    const withCrew = (assignedEmployees || []).filter(emp => Boolean(emp.currentCrew));
    const withoutCrew = (assignedEmployees || []).filter(emp => !emp.currentCrew);

    const sortByLastName = (a, b) => {
      const lastNameA = (a.lastName || '').toLowerCase();
      const lastNameB = (b.lastName || '').toLowerCase();
      return lastNameA.localeCompare(lastNameB);
    };

    withCrew.sort(sortByLastName);
    withoutCrew.sort(sortByLastName);
    const sortedEmployees = [...withCrew, ...withoutCrew];
    setAssignedEmployees(sortedEmployees);
    setAssignDate(data.date);
    setRemovedEmployees(prev => {
      const selectedIds = new Set((data.employees || []).map(emp => emp.id));
      const filteredPrev = prev.filter(emp => !selectedIds.has(emp.id));
      const all = [...filteredPrev, ...(data.removed || [])];
      const seen = new Set();
      return all.filter(emp => {
        if (!emp || !emp.id) return false;
        if (seen.has(emp.id)) return false;
        seen.add(emp.id);
        return true;
      });
    });
    setEditEmployeeStatus(data.employeeAssignedEdit);
    setCurrentStep(2);
  };

  const handleAssignEmployeePrev = () => setCurrentStep(0);

  const handleSummaryPrev = () => {
    if (assignEmployeeRef.current?.getSelectedEmployees) {
      const data = assignEmployeeRef.current.getSelectedEmployees();
      if (data && Array.isArray(data.removed)) {
        setRemovedEmployees(prev => {
          const selectedIds = new Set((data.employees || []).map(emp => emp.id));
          const filteredPrev = prev.filter(emp => !selectedIds.has(emp.id));
          const all = [...filteredPrev, ...(data.removed || [])];
          const seen = new Set();
          return all.filter(emp => {
            if (!emp || !emp.id) return false;
            if (seen.has(emp.id)) return false;
            seen.add(emp.id);
            return true;
          });
        });
      }
    }
    setCurrentStep(1);
  };
  const handleSaveCrew = async (employees) => {
    setLoading(true);
    try {
      const assignDateFormatted = dayjs(assignDate).format('YYYY-MM-DD');
      const startTime = dayjs(basicDetails.startTime).format('HH:mm');
      const endTime = dayjs(basicDetails.endTime).format('HH:mm');
      const employeeIds = employees.map(emp => ({ id: emp.id }));
      const employeesForUKG = employees.map(emp => ({
        // ...emp,
         id: emp?.id,
        workRuleTransfer:basicDetails?.workRuleTransfer,
        payscale: basicDetails?.payScale,
        wbsIo: basicDetails?.eventName,
        task: basicDetails?.task,
        premium: basicDetails?.premium,
        scheduleIn: emp?.scheduleIn,
        scheduleOut:emp?.scheduleOut,
        assignDate: assignDateFormatted,
        assignedAt: new Date().toISOString(),
        
        }));
        const payload = {
  crews: [
    {
      crewDetails: {
        ...basicDetails,
        date: assignDate,
        startTime,
        endTime,
        crewOwner: userConfig?.userid,
      },
      employeesToAssign: employeeIds,
    },
  ],
};
const res = await createCrew(payload);
      const body = res?.data?.results[0] ?? res;
      const crewId = body?.crewId || body?.data?.crewId || res?.crewId || null;
      setCreatedCrewId(crewId);
     let conflicts = [];
      if (Array.isArray(body?.conflictingEmployees)) conflicts = body.conflictingEmployees;
      else if (Array.isArray(body)) {
        conflicts = body;
      } else if (Array.isArray(body?.data)) {
        conflicts = body.data;
      } else if (Array.isArray(res)) conflicts = res;
      const successes = body?.createdAssignments ?? body?.createdAssignmentsCount ?? [];
      
      const conflictIds = new Set(conflicts.map(c => c.employeeId));
          const validEmployees = employees.filter(row => !conflictIds.has(row.employeeId));
          const validEmployeesToAssignUKG = validEmployees.map(emp => ({
          id: emp?.id,
          workRuleTransfer:basicDetails?.workRuleTransfer,
          payscale: basicDetails?.payScale,
          wbsIo: basicDetails?.eventName,
          task: basicDetails?.task,
          premium: basicDetails?.premium,
          scheduleIn: emp?.scheduleIn,
          scheduleOut:emp?.scheduleOut,
          assignDate: assignDateFormatted,
          assignedAt: new Date().toISOString(),
        }));
      if (validEmployees.length > 0) {
        const response = await CrewScheduleWorkmen(validEmployeesToAssignUKG);
        setIntegrationResponse(response.data.results);
      }
      if ((successes?.length || 0) > 0) {
        setTimeout(() => { message.success("Crew Created Successfully", 5) }, 2100);
      } else {
        message.success("Crew Created Successfully", 5);
      }
      RemoveFilters(userConfig);
      if (employees?.length === 0) {setTimeout(() => {window.location.reload()}, 5000); return;};
      setSuccessAssignments(successes);
      setConflictAssignments(conflicts || []);
      setLoading(false)
      setScheduleModalVisible(true);
    } catch (err) {
      console.error(err);
      message.error('Error creating crew or assigning employees.');
      setLoading(false); 
    }
  };
const handleOverrideSchedule = async (selectedConflicts = null) => {
    try {
      const conflictsToUse = Array.isArray(selectedConflicts) && selectedConflicts.length ? selectedConflicts : conflictAssignments;
      if (!conflictsToUse || conflictsToUse.length === 0) {
        message.warning('No conflicts to override.');
        return;
      }
const flattened = conflictsToUse.flatMap(item => {
        if (Array.isArray(item.conflicts) && item.conflicts.length) return item.conflicts;
        if (item && item._id) return [item];
        return [];
      });
if (!flattened.length) {
        message.warning('No conflict assignment objects found.');
        return;
      }

      // for (const c of flattened) {
      //   const payload = {
      //     newCrewId: createdCrewId || '',
      //     start: dayjs(basicDetails?.startTime).format('HH:mm'),
      //     end: dayjs(basicDetails?.endTime).format('HH:mm'),
      //     date: dayjs(assignDate).format('YYYY-MM-DD'),
      //     conflictingEmployees: [
      //       {
      //         _id: c._id,
      //         crew: c.crew,
      //         isScheduleOverridden: c.isScheduleOverridden,
      //         employeeId: c.employeeId,
      //         date: c.date,
      //         start: c.start,
      //         end: c.end,
      //         createdAt: c.createdAt,
      //       },
      //     ],
      //   };

      //   await scheduleOverride(payload);
      // }

      const payload = {
  newCrewId: createdCrewId || '',
     start: dayjs(
      basicDetails?.startTime
     ).format('HH:mm'),
     end: dayjs(
     basicDetails?.endTime
    ).format('HH:mm'),

  date: dayjs(assignDate)
    .format('YYYY-MM-DD'),

  // ✅ Combine all conflicts here
  conflictingEmployees: flattened.map(c => ({
    _id: c._id,
    crew: c.crew,
    isScheduleOverridden:
      c.isScheduleOverridden,
    employeeId: c.employeeId,
    date: c.date,
    start: c.start,
    end: c.end,
    createdAt: c.createdAt,
  }))
};
// ✅ Only ONE API call
await scheduleOverride(payload);
   const assignDateFormatted = dayjs(assignDate)?.format('YYYY-MM-DD');
  const updatedFlattened = flattened.map(item => ({
  id: item?.employeeId || item?.id,
      shiftId: item?.shiftId,
      workRuleTransfer:basicDetails?.workRuleTransfer,
        payscale: basicDetails?.payScale,
        wbsIo: basicDetails?.eventName,
        task: basicDetails?.task,
        premium: basicDetails?.premium,
        scheduleIn: dayjs(basicDetails?.startTime).format('HH:mm'),
          scheduleOut: dayjs(basicDetails?.endTime).format('HH:mm'),
          startTime:item?.start,
           endTime:item?.end,
        assignDate:basicDetails?.date || assignDateFormatted,
    }));
      await replaceScheduleWorkmen(updatedFlattened);
      message.success('Schedule override completed');
      setScheduleModalVisible(false);
      onClose?.();
    } catch (err) {
      console.error('Override failed:', err);
      message.error('Error overriding schedule.');
    }
  };
const handleCancelSchedule = () => {
    setScheduleModalVisible(false);
    resetStepper();
    onClose?.();
  };
const steps = ['Basic Details', initialValues?.mode === 'edit'? 'Manage Crew Members':'Assign Employees', 'Summary'];
return (
    <div>
      <h1 style={{ textAlign: 'center', fontWeight: 'bold', color: 'black' }}>
        {basicDetails?.crewName}
      </h1>

      <div className="crew-stepper">
        {steps.map((label, idx) => (
          <React.Fragment key={label}>
            <div className={`crew-stepper-item${currentStep === idx ? ' active' : ''}`}>
              <span className="crew-stepper-circle">{idx + 1}</span>
              <span className="crew-stepper-label">{label}</span>
            </div>
            {idx < steps.length - 1 && <div className="crew-stepper-line" />}
          </React.Fragment>
        ))}
      </div>

      {/* Step Content */}
      <div style={{ marginTop: 32 }}>
        {currentStep === 0 && (
          <BasicDetails
            key={formKey}
            ref={basicDetailsRef}
            initialValues={basicDetails}
            onChange={setBasicDetails}
            onNext={handleBasicDetailsNext}
            templateAccess={templateAccess}
          />
        )}
{currentStep === 1 && (
        <AssignEmployee
            ref={assignEmployeeRef}
            basicDetails={basicDetails}
            initialEmployees={assignedEmployees}
            onPrev={handleAssignEmployeePrev}
            onNext={handleAssignEmployeeNext}
            selectedDate={selectedDate}
            mode={initialValues?.mode}
            scheduleOverridePermission={scheduleOverridePermission}
        />
      )}        {currentStep === 2 && (
          <Summary
            basicDetails={basicDetails}
            employees={assignedEmployees}
            assignDate={assignDate}
            removed={removedEmployees}
            editEmployeeStatus={editEmployeeStatus}
            onPrev={handleSummaryPrev}
            onSave={handleSaveCrew}
            loading={loading}
            scheduleOverridePermission={scheduleOverridePermission}
          />
        )}
      </div>

      <Modal
        // open={scheduleModalVisible}
        open={scheduleModalVisible && loading !== true}
        footer={null}
        closable
        onCancel={handleCancelSchedule}
        width={950}
        bodyStyle={{ padding: 0, borderRadius: 12, overflow: 'hidden' }}
      >
        <ScheduleStatus
          assignedEmployees={assignedEmployees}
          assignDate={dayjs(assignDate)?.format('MM-DD-YYYY')}
          onOverride={handleOverrideSchedule}
          onCancel={handleCancelSchedule}
          successToAssign={successAssignments}
          conflictToAssign={conflictAssignments}
          integrationResponse={integrationResponse}
          scheduleOverridePermission={scheduleOverridePermission}
          onResetStepper={resetStepper}
        />
      </Modal>

      {/* Styles */}
      <style>{`
        .crew-stepper {
          display: flex;
          align-items: center;
          margin-bottom: 24px;
        }
        .crew-stepper-item {
          display: flex;
          align-items: center;
          color: #888;
          font-size: 14px;
        }
        .crew-stepper-item.active {
          color: #1677ff;
          font-weight: 500;
        }
        .crew-stepper-circle {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          background: #f0f0f0;
          color: #888;
          font-size: 13px;
          margin-right: 6px;
        }
        .crew-stepper-item.active .crew-stepper-circle {
          background: #1677ff;
          color: #fff;
        }
        .crew-stepper-line {
          flex: 1;
          height: 2px;
          background: #eee;
          margin: 0 8px;
        }
      `}</style>
    </div>
  );
};

export default MainStepper;
   

